import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useRefundChargebackReportFilterFields } from './hooks/useRefundChargebackReportFilterFields';

export type RefundChargebackReportListFilterValues = {
  appliedDate?: DateRangeValue;
  updatedDate?: DateRangeValue;
  createdAt: {
    gte: number;
    lte: number;
  };
  updatedAt: {
    gte: number;
    lte: number;
  };
  company: string | null;
  merchant: string | null;
  provider: string | null;
  merchantAccount: string[];
  gateway: string[];
  method: string[];
  status: string[];
  impactToBalance: string | null;
  currency: string[];
  conversionCurrency: string | null;
  summary: boolean | string | null;
  id: string;
  merchantReference: string;
  providerReferenceId: string;
  transaction: string;
  timezone: DateRangeTimezoneValue;
};

export const RefundChargebackReportFilter: React.FC = () => {
  const fields = useRefundChargebackReportFilterFields();

  return <FilterFields fields={fields} />;
};
